import React from "react";
import { StatsCard } from "../ui";

/**
 * Dashboard KPI card.
 *
 * The implementation now lives in `ui/StatsCard` so the dashboard, the
 * enquiries pipeline and every other page render the identical card. This
 * stays as a thin adapter for the dashboard's `iconClass` prop and keeps the
 * `db-kpi-card` class on the root, which page SCSS still hooks into
 * (e.g. `.eq-kpis .db-kpi-card`).
 */
const StatCard = ({ iconClass, className = "", ...rest }) => (
  <StatsCard
    {...rest}
    iconColor={iconClass}
    className={`db-kpi-card ${className}`.trim()}
  />
);

export default StatCard;
